(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7376],{

/***/ 34900:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fredcon26",
      function () {
        return __webpack_require__(82309);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 66334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ faXTwitter; },
/* harmony export */   "n": function() { return /* binding */ XTwitterIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);



var faXTwitter = {
    prefix: "fab",
    iconName: "x-twitter",
    icon: [
        512,
        512,
        [],
        "f099",
        "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 240.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
    ]
};
var XTwitterIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        icon: faXTwitter
    }, props));
};


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 82309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ fredcon26; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./components/shared/XTwitterIcon.tsx
var XTwitterIcon = __webpack_require__(66334);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/Fredcon26.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  /* Aggressive Root Reset */\n  html, body {\n    overflow: hidden !important;\n    height: 100% !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  /* Hide native cursor everywhere */\n  :root, html, body, #__next, #fredcon-page-wrapper, #CybotCookiebotDialog, #freshworks-container, .react-toast-notifications__container, * {\n    cursor: none !important;\n  }\n\n  /* Restore native cursor for Cookiebot dialog for usability */\n  #CybotCookiebotDialog, #CybotCookiebotDialog *, #CookiebotSessionDialog, #CookiebotSessionDialog * {\n    cursor: auto !important;\n  }\n  #CybotCookiebotDialog a, #CybotCookiebotDialog button, #CybotCookiebotDialog [role="button"], #CybotCookiebotDialog .CybotCookiebotDialogBodyButton,\n  #CookiebotSessionDialog a, #CookiebotSessionDialog button, #CookiebotSessionDialog [role="button"] {\n    cursor: pointer !important;\n  }\n\n  /* Restore native cursor for text inputs for usability */\n  input, textarea {\n    cursor: text !important;\n  }\n\n  /* Restore native cursor for disabled state if needed, though we probably want it hidden too to show our custom not-allowed state if we add it */\n  [disabled], .disabled {\n    cursor: none !important;\n  }\n\n  /* Ensure our custom scrollbar thumb doesn\'t show native cursor */\n  ::-webkit-scrollbar-thumb {\n    cursor: none !important;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: white;\n  z-index: 1; /* Reset z-index since custom cursor will be 2147483647 */\n\n  /* Scrollbar styling */\n  &::-webkit-scrollbar {\n    width: 12px;\n  }\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #3053f9;\n    border-radius: 6px;\n    border: 3px solid #f1f1f1;\n  }\n  &::-webkit-scrollbar-thumb:hover {\n    background: #1117d7;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  h1 {\n    font-size: 128px;\n    line-height: 1;\n    position: relative;\n    margin-bottom: 0.25rem;\n\n    :after {\n      content: '';\n      display: inline-block;\n      margin-left: 1.5rem;\n      background: url('/images/fredcon26/logo.png') no-repeat 0 0;\n      width: 115px;\n      height: 115px;\n      margin-bottom: -1.5rem;\n    }\n\n    @media (max-width: ",
        ") {\n      font-size: 75px;\n    }\n\n    @media (max-width: ",
        ") {\n      font-size: 50px;\n      text-align: center;\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n      margin-bottom: 0.75rem;\n\n      :after {\n        margin: 1rem auto 0 auto;\n      }\n    }\n  }\n\n  h1 span {\n    display: block;\n    font-weight: normal;\n    font-size: ",
        ";\n  }\n\n  h2 {\n    font-size: 50px;\n    line-height: 1;\n    position: relative;\n    margin-bottom: 1.5rem;\n\n    @media (max-width: ",
        ") {\n      font-size: 42px;\n    }\n\n    @media (max-width: ",
        ") {\n      font-size: 28px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  overflow: hidden; /* Prevent any internal content from forcing screen width */\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  margin: 0;\n  padding: clamp(6px, 1vw, 12px)\n    clamp(",
        ", 1.5vw, ",
        ");\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: clamp(56px, 7vw, 90px);\n  flex-wrap: nowrap;\n\n  @media (max-width: ",
        ") {\n    justify-content: flex-start;\n    gap: 8px;\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    height: clamp(64px, 10vw, 130px);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  flex-wrap: nowrap;\n  flex-shrink: 0; /* Don't allow the group itself to shrink below its content */\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    padding-bottom: 4px;\n    padding-right: 4px;\n    width: clamp(120px, calc(50vw - 400px), 200px);\n    height: auto;\n    display: block;\n\n    @media (max-width: ",
        ") {\n      width: 88px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 24px;\n  min-width: 0; /* Allow shrinking */\n\n  @media (max-width: ",
        ") {\n    margin-left: 0;\n    flex: 1;\n    justify-content: flex-end;\n    gap: 16px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  padding-top: 12px;\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media (max-width: ",
        ") {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #3053f9;\n    color: ",
        ";\n    width: 36px;\n    height: 36px;\n    padding: 10px;\n    border: none;\n    /* cursor: pointer removed */\n    z-index: 100;\n  }\n\n  @media (max-width: ",
        ") {\n    position: fixed;\n    top: 12px;\n    left: 16px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* cursor: pointer removed */\n  position: relative;\n  height: 32px;\n\n  a {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-weight: 500;\n    font-size: clamp(14px, 1.2vw, 18px);\n    text-transform: uppercase;\n    color: #3053f9;\n    line-height: 1;\n    text-decoration: none;\n    white-space: nowrap;\n  }\n\n  .underline {\n    display: none;\n    flex-wrap: wrap;\n    width: 100%;\n    height: 6px;\n    justify-content: center;\n    overflow: hidden;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n  }\n\n  &:hover {\n    .underline {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 4px;\n  height: 4px;\n  background-color: ",
        ";\n  opacity: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  display: none; /* Old implementation */\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none; /* Not in the new design */\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    min-height: clamp(500px, 80vh, 1000px);\n    width: 100%;\n    position: relative;\n    background: #3053f9 url('/images/fredcon26/hero-background-animated.svg')\n      no-repeat center;\n    background-size: cover;\n    padding: ",
        " ",
        ";\n    color: ",
        ";\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    margin-bottom: 0;\n\n    @media (max-width: ",
        ") {\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n    }\n\n    @media (max-width: ",
        ") {\n      min-height: 500px;\n      padding: 80px ",
        ";\n    }\n\n    @media (max-width: calc(",
        ")) {\n      background-image: url('/images/fredcon26/reticula-mobile-animated.svg');\n      background-position: right center;\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  gap: 24px;\n  padding: ",
        ";\n\n  @media (min-width: 939px) and (max-width: 1182px) {\n    transform: translateX(calc((100vw - 939px) * 0.369));\n  }\n\n  @media (min-width: 1183px) and (max-width: 1500px) {\n    transform: translateX(calc(90px - (100vw - 1183px) * 0.284));\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-weight: 400;\n  font-size: 20px;\n  text-transform: uppercase;\n  line-height: 20px;\n  margin: 0;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  .logo-img {\n    width: clamp(240px, 50vw, 640px);\n    height: auto;\n    display: block;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n\n  p {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-size: 20px;\n    text-transform: capitalize;\n    margin: 0;\n  }\n\n  img {\n    width: clamp(140px, 25vw, 280px);\n    height: auto;\n    display: block;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-size: clamp(19px, 2.2vw, 28px);\n  font-weight: 400;\n  line-height: 1.2;\n  text-transform: uppercase;\n  max-width: 700px;\n  margin: 0;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  background-color: #ffb6fb;\n  padding: 16px 20px;\n  color: ",
        ";\n  max-width: 100%;\n\n  p {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-size: clamp(19px, 1.5vw, 20px);\n    font-weight: 400;\n    text-transform: uppercase;\n    margin: 0;\n    white-space: nowrap;\n\n    @media (max-width: ",
        ") {\n      white-space: normal;\n      text-align: left;\n    }\n  }\n\n  @media (max-width: ",
        ") {\n    padding: 16px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    width: 100%;\n    position: relative;\n    background: #836fff url('/images/fredcon26/reticula-2-animated.svg')\n      no-repeat center;\n    background-size: cover;\n    background-position: center center;\n    padding: ",
        " 0;\n    color: ",
        ";\n    overflow: hidden;\n\n    @media (max-width: ",
        ") {\n      padding: 80px 0;\n    }\n\n    @media (max-width: calc(",
        " - 150px)) {\n      background-image: url('/images/fredcon26/reticula2-mobile-animated.svg');\n      background-position: right top;\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: 0 ",
        ";\n  display: flex;\n  gap: 48px;\n  align-items: flex-start;\n  justify-content: center;\n\n  @media (max-width: ",
        ") {\n    padding: 0 ",
        ";\n  }\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n    text-align: left;\n    padding: 0 ",
        ";\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 540px;\n  width: 100%;\n\n  @media (max-width: ",
        ") {\n    padding-left: 120px;\n  }\n\n  @media (min-width: ",
        ") and (max-width: ",
        ") {\n    padding-left: 0;\n    margin: 0 auto;\n  }\n\n  @media (max-width: ",
        ") {\n    padding-left: 0;\n  }\n\n  @media (max-width: 520px) {\n    padding-right: 16%;\n    padding-top: 12px;\n  }\n\n  h2 {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-size: clamp(28px, 4vw, 48px);\n    line-height: clamp(28px, 4vw, 48px);\n    font-weight: 600;\n    margin-bottom: 20px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-size: clamp(19px, 1.8vw, 20px);\n  line-height: 1.2;\n  width: 100%;\n\n  p {\n    margin: 0;\n    line-height: 1.2;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 540px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: ",
        ") {\n    text-align: left;\n  }\n\n  h2 {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-size: clamp(28px, 4vw, 48px);\n    line-height: clamp(28px, 4vw, 48px);\n    font-weight: 600;\n    margin-bottom: 20px;\n    color: ",
        ";\n  }\n\n  .where-content {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n    @media (min-width: ",
        ") and (max-width: ",
        ") {\n      flex-direction: row;\n      gap: 24px;\n      align-items: flex-start;\n\n      > div {\n        flex: 1;\n      }\n\n      iframe {\n        flex: 1;\n        margin-top: 0;\n      }\n    }\n  }\n\n  iframe {\n    width: 100%;\n    border-radius: 20px;\n    height: 250px;\n    margin-top: 24px;\n    border: none;\n\n    @media (max-width: ",
        ") {\n      margin-bottom: 16px;\n      height: 300px;\n      margin-top: 32px;\n    }\n  }\n\n  @media (max-width: ",
        ") {\n    width: 100%;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-size: clamp(19px, 1.8vw, 20px);\n  line-height: 1.2;\n\n  p {\n    margin: 0;\n    line-height: 1.2;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    width: 100%;\n    padding: ",
        " ",
        ";\n\n    h2 {\n      text-align: center;\n      margin-bottom: 48px;\n      font-family: 'Archivo Narrow', sans-serif;\n      font-size: 52px;\n      line-height: 52px;\n      font-weight: 600;\n      color: ",
        ";\n    }\n\n    @media (max-width: ",
        ") {\n      padding: 80px ",
        ";\n\n      h2 {\n        text-align: left;\n        margin-bottom: ",
        ";\n        font-size: 32px;\n        line-height: 32px;\n      }\n    }\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 800px;\n  margin: 0 auto;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* This component is now replaced by Fredcon26AgendaItem.tsx */\n  display: none;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    width: 100%;\n    padding: ",
        " ",
        ";\n\n    h2 {\n      text-align: center;\n      margin-bottom: 40px;\n      font-family: 'Archivo Narrow', sans-serif;\n      font-size: 52px;\n      line-height: 52px;\n      font-weight: 600;\n      color: ",
        ";\n    }\n\n    @media (max-width: ",
        ") {\n      padding: 80px ",
        ";\n\n      h2 {\n        text-align: left;\n        margin-bottom: ",
        ";\n        font-size: 32px;\n        line-height: 32px;\n      }\n    }\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1328px; /* 5 speakers (240px) + 4 gaps (32px) */\n  margin: 0 auto;\n  margin-top: ",
        ";\n  width: 100%;\n\n  @media (max-width: 1360px) {\n    max-width: 1056px; /* 4 speakers + 3 gaps */\n  }\n\n  @media (max-width: 1080px) {\n    max-width: 784px; /* 3 speakers + 2 gaps */\n  }\n\n  @media (max-width: 820px) {\n    max-width: 512px; /* 2 speakers + 1 gap */\n  }\n\n  @media (max-width: ",
        ") {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    width: 100%;\n    position: relative;\n    background: #ffb6fb url('/images/fredcon26/reticula3-animated.svg')\n      no-repeat center;\n    background-size: cover;\n    padding: ",
        " 0;\n    color: ",
        ";\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n\n    @media (max-width: ",
        ") {\n      padding: 80px 0;\n    }\n\n    @media (max-width: calc(",
        ")) {\n      background-image: url('/images/fredcon26/reticula3-mobile-animated.svg');\n      background-position: right top;\n    }\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 540px;\n  width: 100%;\n  padding: 0 ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  gap: 20px;\n  margin: 0 auto;\n\n  @media (min-width: ",
        ") {\n    margin-left: calc(30vw - 57px);\n    margin-right: auto;\n  }\n\n  @media (min-width: ",
        ") and (max-width: ",
        ") {\n    margin-left: 20vw;\n    margin-right: auto;\n    max-width: 46vw; /* 15% wider than before */\n  }\n\n  @media (min-width: ",
        ") and (max-width: ",
        ") {\n    margin-left: 20vw;\n    margin-right: 45%;\n  }\n\n  @media (min-width: ",
        ") and (max-width: ",
        ") {\n    margin-left: calc(22.28vw - 57px);\n    margin-right: auto;\n    max-width: 40vw;\n  }\n\n  @media (min-width: ",
        ") and (max-width: ",
        ") {\n    padding-right: 35%;\n  }\n\n  @media (min-width: ",
        ") and (max-width: ",
        ") {\n    padding-right: 20%;\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-weight: 400;\n  font-size: clamp(19px, 1.8vw, 20px);\n  text-transform: uppercase;\n  line-height: 20px;\n  margin: 0;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-size: clamp(28px, 4vw, 52px);\n  line-height: 1.1;\n  font-weight: 600;\n  margin: 0;\n  color: ",
        ";\n  max-width: 700px;\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 500px;\n  font-family: 'Archivo Narrow', sans-serif;\n  font-size: clamp(19px, 1.8vw, 20px);\n  font-weight: 400;\n  line-height: 1.5;\n  color: ",
        ";\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Replaced by Tickets component with animated background */\n  display: none;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 32px;\n    padding: ",
        " ",
        ";\n    padding-bottom: ",
        ";\n    margin-bottom: 0;\n\n    h2 {\n      text-align: center;\n      margin: 0;\n      font-family: 'Archivo Narrow', sans-serif;\n      font-size: 52px;\n      line-height: 52px;\n      font-weight: 600;\n      color: ",
        ";\n    }\n\n    @media (max-width: ",
        ") {\n      padding: 80px ",
        ";\n      gap: 32px;\n\n      h2 {\n        font-size: 32px;\n        line-height: 32px;\n      }\n    }\n  }\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  width: 100%;\n  align-items: center;\n\n  @media (max-width: ",
        ") {\n    gap: 48px;\n  }\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  align-items: center;\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 32px 48px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n\n  &.partner-list-3-max {\n    max-width: 800px;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n\n  img {\n    height: ",
        ";\n    width: auto;\n    max-width: 100%;\n    object-fit: contain;\n    display: block;\n    margin: auto;\n    flex-shrink: 0;\n    /* Prevent image distortion in some browsers */\n    aspect-ratio: auto;\n  }\n\n  &:hover {\n    transform: scale(1.05);\n  }\n\n  @media (max-width: ",
        ") {\n    img {\n      height: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 1px;\n  background-color: #becffe;\n  margin: 12px 0 0 0;\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 942px;\n\n  p {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-size: 20px;\n    line-height: 30px;\n    color: ",
        ";\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    strong {\n      font-weight: 700;\n    }\n\n    a {\n      color: #3053f9;\n      text-decoration: underline;\n    }\n  }\n\n  @media (max-width: ",
        ") {\n    p {\n      font-size: 19px;\n      line-height: 24px;\n    }\n  }\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  background-color: white;\n  margin-top: 0;\n  overflow-x: hidden;\n\n  @media (max-width: ",
        ") {\n    background: white\n      url('/images/fredcon26/reticula-footer-mobile-animated.svg') no-repeat\n      bottom center;\n    background-size: cover;\n    background-position: center bottom;\n    padding-bottom: 2vh;\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 2rem auto 0 auto;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 80%;\n  margin: 0 auto;\n  position: relative;\n  padding: 7% 4rem 0 4rem;\n  gap: clamp(32px, 8vw, 120px);\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100vw;\n    height: 100%;\n    background: white url('/images/fredcon26/reticula-footer-animated.svg')\n      no-repeat top center;\n    background-size: 100% auto;\n    background-position: right top;\n    z-index: 0;\n  }\n\n  /* Ensure content is above the pseudo-element background */\n  > * {\n    position: relative;\n    z-index: 1;\n  }\n\n  @media (min-width: ",
        ") {\n    min-height: 200px;\n  }\n\n  @media (max-width: ",
        ") {\n    padding-bottom: 2%;\n  }\n\n  @media (max-width: ",
        ") {\n    max-width: 100%;\n    padding: 5% 4rem 0 4rem;\n    align-items: center;\n    gap: clamp(16px, 4vw, 32px);\n    min-height: 120px;\n  }\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    align-items: center;\n    gap: 48px;\n    max-width: 100%;\n    padding: ",
        " ",
        " 0 ",
        ";\n    min-height: auto;\n\n    &:before {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n\n  span {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-size: clamp(14px, 1.2vw, 20px);\n    line-height: 1;\n    color: ",
        ";\n  }\n\n  img {\n    height: clamp(20px, 2.5vw, 42px);\n    width: auto;\n  }\n\n  @media (max-width: ",
        ") {\n    align-items: center;\n    text-align: center;\n\n    span {\n      font-size: 24px;\n    }\n\n    img {\n      height: 52px;\n    }\n  }\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n\n  span {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-size: clamp(14px, 1.2vw, 20px);\n    line-height: 1;\n    color: ",
        ";\n  }\n\n  img {\n    height: clamp(16px, 1.8vw, 32px);\n    width: auto;\n  }\n\n  @media (max-width: ",
        ") {\n    align-items: center;\n    text-align: center;\n\n    span {\n      font-size: 24px;\n    }\n\n    img {\n      height: 40px;\n    }\n  }\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    height: clamp(12px, 1.2vw, 20px);\n    width: auto;\n  }\n\n  @media (max-width: ",
        ") {\n    img {\n      height: 24px;\n    }\n  }\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 942px;\n  margin: 8px auto 20px auto;\n  padding: 0 ",
        ";\n  gap: 32px;\n\n  @media (max-width: ",
        ") {\n    gap: 12px;\n  }\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    gap: 24px;\n    text-align: center;\n    margin: 0 auto;\n    padding-bottom: 0;\n  }\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-size: 16px;\n  color: ",
        ";\n\n  strong {\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 24px;\n\n  a {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-size: 16px;\n    text-decoration: none;\n    color: #3053f9;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  @media (max-width: ",
        ") {\n    gap: 8px;\n  }\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    gap: 16px;\n  }\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 16px;\n  align-items: center;\n\n  a {\n    color: #3053f9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: opacity 0.2s ease;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    svg,\n    div {\n      width: 20px;\n      height: 20px;\n      font-size: 20px;\n\n      @media (max-width: ",
        ") {\n        width: 32px;\n        height: 32px;\n        font-size: 32px;\n      }\n    }\n  }\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}


var Fredcon26GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject());
var PageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-0"
})(_templateObject1());
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-1"
})(_templateObject2(), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md"));
// Header -------
var Fredcon26_styled_Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-c3c02b44-2"
})(_templateObject3(), (0,theme/* color */.$_)("white"));
var HeaderContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-3"
})(_templateObject4(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var HeaderGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-4"
})(_templateObject5(), (0,theme/* spacing */.W0)("md"));
var HeaderNavLogo = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-c3c02b44-5"
})(_templateObject6(), (0,theme/* screen */.sp)("md2"));
var HeaderActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-6"
})(_templateObject7(), (0,theme/* screen */.sp)("md2"));
var HeaderNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-c3c02b44-7"
})(_templateObject8(), (0,theme/* screen */.sp)("md2"));
var MobileMenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c3c02b44-8"
})(_templateObject9(), (0,theme/* screen */.sp)("md2"), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("smMax"));
var NavItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-9"
})(_templateObject10());
var Pixel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-10"
})(_templateObject11(), function(param) {
    var _$color = param.color;
    return _$color || "#3053f9";
}, function(param) {
    var opacity = param.opacity;
    return opacity !== undefined ? opacity : 1;
});
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-11"
})(_templateObject12(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var HeaderNotice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-12"
})(_templateObject13());
// /Header -------
// Hero -------
var Hero = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c3c02b44-13"
})(_templateObject14(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md2"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var HeroInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-14"
})(_templateObject15(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"));
var HeroSubTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-c3c02b44-15"
})(_templateObject16());
var HeroTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-16"
})(_templateObject17());
var PoweredBy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-17"
})(_templateObject18());
var HeroTagline = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-c3c02b44-18"
})(_templateObject19());
var HeroDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-19"
})(_templateObject20(), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("md2"));
// /Hero -------
// What/Where -------
var InfoWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c3c02b44-20"
})(_templateObject21(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("md"));
var InfoInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-21"
})(_templateObject22(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md2"), (0,theme/* spacing */.W0)("md"));
var What = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-22"
})(_templateObject23(), (0,theme/* screen */.sp)("xl2"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md2"), (0,theme/* color */.$_)("white"));
var WhatDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-23"
})(_templateObject24());
var Where = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-24"
})(_templateObject25(), (0,theme/* screen */.sp)("md2"), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("md2"));
var WhereDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-25"
})(_templateObject26());
// /What/Where -------
// Agenda -------
var Agenda = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c3c02b44-26"
})(_templateObject27(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var AgendaList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-27"
})(_templateObject28());
var AgendaItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-28"
})(_templateObject29());
var AgendaItemTime = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-29"
})(_templateObject30());
var AgendaItemContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-30"
})(_templateObject31());
// /Agenda -------
// Speakers -------
var Speakers = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c3c02b44-31"
})(_templateObject32(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var SpeakersContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-32"
})(_templateObject33(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"));
// /Speakers -------
// Tickets -------
var Tickets = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c3c02b44-33"
})(_templateObject34(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("md"));
var TicketsInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-34"
})(_templateObject35(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("xl2"), (0,theme/* screen */.sp)("xl"), (0,theme/* screen */.sp)("xl2Max"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("xlMax"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("sm"), (0,theme/* screen */.sp)("md"));
var TicketsSubTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-c3c02b44-35"
})(_templateObject36());
var TicketsTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-c3c02b44-36"
})(_templateObject37(), (0,theme/* color */.$_)("black"));
var TicketsDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-37"
})(_templateObject38(), (0,theme/* color */.$_)("black"));
var TicketsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-38"
})(_templateObject39());
// /Tickets -------
// Partners -------
var Partners = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c3c02b44-39"
})(_templateObject40(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md2"), (0,theme/* spacing */.W0)("md"));
var Tiers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-40"
})(_templateObject41(), (0,theme/* screen */.sp)("md2"));
var Tier = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-41"
})(_templateObject42());
var PartnerList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-42"
})(_templateObject43());
var Partner = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-c3c02b44-43"
})(_templateObject44(), function(param) {
    var tier = param.tier;
    if (tier === "king") return "72px";
    if (tier === "partner") return "44px";
    return "28px";
}, (0,theme/* screen */.sp)("md2"), function(param) {
    var tier = param.tier;
    if (tier === "king") return "60px";
    if (tier === "partner") return "40px";
    return "32px";
});
var PartnersDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-44"
})(_templateObject45());
var PartnersFooterText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-45"
})(_templateObject46(), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md2"));
// /Partners -------
// Footer -------
var Footer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-c3c02b44-46"
})(_templateObject47(), (0,theme/* screen */.sp)("md"));
var FooterContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-47"
})(_templateObject48());
var FooterRow1 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-48"
})(_templateObject49(), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var FredConLogoBlack = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-49"
})(_templateObject50(), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md"));
var PoweredByGoogleBlack = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-50"
})(_templateObject51(), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md"));
var ManfredLogoMonocolor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-51"
})(_templateObject52(), (0,theme/* screen */.sp)("md"));
var FooterRow2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-52"
})(_templateObject53(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("md"));
var Copyright = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c3c02b44-53"
})(_templateObject54(), (0,theme/* color */.$_)("black"));
var FooterLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-54"
})(_templateObject55(), (0,theme/* screen */.sp)("md2"), (0,theme/* screen */.sp)("md"));
var SocialLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c3c02b44-55"
})(_templateObject56(), (0,theme/* screen */.sp)("md")); // /Footer -------

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/Fredcon26MobileMenu.styled.ts

function Fredcon26MobileMenu_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  display: ",
        ";\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100%;\n  max-width: 400px;\n  height: 100%;\n  background-color: ",
        ";\n  z-index: 1001;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transform: ",
        ";\n  transition: transform 0.3s ease-in-out;\n  overflow-y: auto;\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 32px;\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-size: 19px;\n  text-transform: uppercase;\n  color: ",
        ";\n  margin: 0;\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    height: 35px;\n    width: auto;\n  }\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #3053f9;\n  color: ",
        ";\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  /* cursor: pointer removed */\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding-top: 16px;\n\n  .menu-ticket-button {\n    margin-top: 24px;\n    max-width: 250px;\n  }\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* cursor: pointer removed */\n  position: relative;\n  height: 36px;\n  width: fit-content;\n\n  a {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-weight: 500;\n    font-size: 24px;\n    text-transform: uppercase;\n    color: #3053f9;\n    line-height: 24px;\n    text-decoration: none;\n    white-space: nowrap;\n  }\n\n  .underline {\n    display: none;\n    flex-wrap: wrap;\n    width: 100%;\n    height: 8px;\n    justify-content: center;\n    overflow: hidden;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n  }\n\n  &:hover {\n    .underline {\n      display: flex;\n    }\n  }\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 4px;\n  height: 4px;\n  background-color: ",
        ";\n  opacity: ",
        ";\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  margin-top: auto;\n  padding-top: 32px;\n  z-index: 1;\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 1px;\n  background-color: #becffe;\n  width: 100%;\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-weight: 500;\n  font-size: 20px;\n  color: ",
        ";\n  margin: 0;\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-weight: 500;\n  font-size: 20px;\n  color: #3053f9;\n  text-decoration: none;\n  /* cursor: pointer removed */\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 16px;\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #3053f9;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease;\n\n  span,\n  svg {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  path {\n    width: 100%;\n    height: 100%;\n  }\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function Fredcon26MobileMenu_styled_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n  right: ",
        ";\n  width: ",
        ";\n  height: 50px;\n  background-color: ",
        ";\n  pointer-events: none;\n  z-index: -1;\n"
    ]);
    Fredcon26MobileMenu_styled_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}


var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-0"
})(Fredcon26MobileMenu_styled_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "block" : "none";
});
var MenuPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-1"
})(Fredcon26MobileMenu_styled_templateObject1(), (0,theme/* color */.$_)("white"), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "translateX(0)" : "translateX(100%)";
}, (0,theme/* screen */.sp)("md2"));
var MenuHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-2"
})(Fredcon26MobileMenu_styled_templateObject2());
var Fredcon26MobileMenu_styled_HeaderContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-3"
})(Fredcon26MobileMenu_styled_templateObject3());
var HeaderSubTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-35dc47ba-4"
})(Fredcon26MobileMenu_styled_templateObject4(), (0,theme/* color */.$_)("black"));
var HeaderLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-5"
})(Fredcon26MobileMenu_styled_templateObject5());
var CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-35dc47ba-6"
})(Fredcon26MobileMenu_styled_templateObject6(), (0,theme/* color */.$_)("white"));
var MenuItems = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-35dc47ba-7"
})(Fredcon26MobileMenu_styled_templateObject7());
var MenuItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-8"
})(Fredcon26MobileMenu_styled_templateObject8());
var Fredcon26MobileMenu_styled_Pixel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-9"
})(Fredcon26MobileMenu_styled_templateObject9(), function(param) {
    var _$color = param.color;
    return _$color || "#3053f9";
}, function(param) {
    var opacity = param.opacity;
    return opacity !== undefined ? opacity : 1;
});
var Fredcon26MobileMenu_styled_Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-10"
})(Fredcon26MobileMenu_styled_templateObject10());
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-11"
})(Fredcon26MobileMenu_styled_templateObject11());
var Fredcon26MobileMenu_styled_FooterLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-12"
})(Fredcon26MobileMenu_styled_templateObject12());
var Fredcon26MobileMenu_styled_Copyright = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-35dc47ba-13"
})(Fredcon26MobileMenu_styled_templateObject13(), (0,theme/* color */.$_)("black"));
var FooterLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-35dc47ba-14"
})(Fredcon26MobileMenu_styled_templateObject14());
var SocialMedia = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-15"
})(Fredcon26MobileMenu_styled_templateObject15());
var SocialIcon = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-35dc47ba-16"
})(Fredcon26MobileMenu_styled_templateObject16());
var DecorativeSquare = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35dc47ba-17"
})(Fredcon26MobileMenu_styled_templateObject17(), function(param) {
    var top = param.top;
    return top || "auto";
}, function(param) {
    var left = param.left;
    return left || "auto";
}, function(param) {
    var right = param.right;
    return right || "auto";
}, function(param) {
    var width = param.width;
    return width || "50px";
}, function(param) {
    var _$color = param.color;
    return _$color;
});

;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/Fredcon26TicketButton.tsx

function Fredcon26TicketButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-weight: 400;\n  font-size: clamp(18px, 1.2vw, 18px);\n  text-transform: uppercase;\n  color: ",
        ";\n  text-decoration: none;\n  text-underline-position: from-font;\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  @media (max-width: ",
        ") {\n    font-size: 19px;\n    line-height: 19px;\n    white-space: normal;\n    text-align: left;\n  }\n"
    ]);
    Fredcon26TicketButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Fredcon26TicketButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: clamp(40px, 6vw, 64px);\n  align-items: stretch;\n  cursor: pointer;\n  min-width: 0;\n  position: relative;\n  border: none;\n  outline: none;\n\n  .button-body {\n    background-color: #c5fe79;\n    display: flex;\n    align-items: center;\n    padding: 0 clamp(8px, 1.5vw, 20px);\n    flex: 1;\n    border: none;\n    outline: none;\n    position: relative;\n    z-index: 2;\n    margin-right: -2px; /* Small overlap to bridge the gap from the body side */\n  }\n\n  .button-tail {\n    width: clamp(30px, 5vw, 60px);\n    background: url('/images/fredcon26/button-tail.svg') no-repeat 0 0;\n    background-size: 100% 100%;\n    flex-shrink: 0;\n    margin-left: -8px; /* Increased overlap for larger scales */\n    position: relative;\n    z-index: 1;\n    border: none;\n    outline: none;\n\n    @media (max-width: ",
        ") {\n      background-image: url('/images/fredcon26/button-tail-mobile.svg');\n      margin-left: -4px;\n    }\n  }\n\n  a,\n  button {\n    ",
        "\n    outline: none !important;\n    border: none !important;\n    box-shadow: none !important;\n  }\n"
    ]);
    Fredcon26TicketButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Fredcon26TicketButton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Fredcon26TicketButton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var linkStyles = (0,styled_components_browser_esm/* css */.iv)(Fredcon26TicketButton_templateObject(), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md2"));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-363db4bf-0"
})(Fredcon26TicketButton_templateObject1(), (0,theme/* screen */.sp)("md2"), linkStyles);
var StyledLinkScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
    componentId: "sc-363db4bf-1"
})(Fredcon26TicketButton_templateObject2(), linkStyles);
var Fredcon26TicketButton = function(param) {
    var className = param.className, href = param.href, text = param.text;
    var t = (0,useI18n/* useI18n */.Q)("fredcon26").t;
    var DEFAULT_LUMA_URL = "https://luma.com/4vot95mb";
    var targetHref = href || DEFAULT_LUMA_URL;
    var isInternal = targetHref.startsWith("#");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "".concat(className, " cursor-pointer"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "button-body",
                children: isInternal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinkScroll, {
                    to: targetHref.substring(1),
                    duration: 500,
                    offset: -64,
                    className: "cursor-pointer",
                    containerId: "fredcon-page-wrapper",
                    children: text || t("fredcon.get-ticket")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: targetHref,
                    target: "_blank",
                    rel: "noreferrer",
                    className: "cursor-pointer",
                    children: text || t("fredcon.get-ticket")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "button-tail"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/TelegramIcon.tsx

function TelegramIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background-color: currentColor;\n  mask: url('/images/fredcon26/telegram-icon.svg') no-repeat center;\n  mask-size: contain;\n  display: inline-block;\n"
    ]);
    TelegramIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dddcf728-0"
})(TelegramIcon_templateObject());
var TelegramIcon = function(param) {
    var className = param.className, style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
        className: className,
        style: style
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/Fredcon26MobileMenu.tsx











var Fredcon26MobileMenu = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var t = (0,useI18n/* useI18n */.Q)("fredcon26").t;
    var pixelSequence = [
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#c5fe79"
        },
        {
            color: "#3053f9"
        },
        {
            color: "#ffb6fb"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9"
        },
        {
            color: "#ffb6fb"
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#c5fe79"
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#ff6e23"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9"
        },
        {
            color: "#836fff"
        },
        {
            color: "#c5fe79",
            opacity: 0
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#ff6e23"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#3053f9"
        },
        {
            color: "#c5fe79",
            opacity: 0
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#ffb6fb"
        },
        {
            color: "#3053f9"
        },
        {
            color: "#836fff"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#3053f9"
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#3053f9"
        },
        {
            color: "#836fff"
        },
        {
            color: "#c5fe79",
            opacity: 0
        },
        {
            color: "#3053f9",
            opacity: 0
        },
        {
            color: "#3053f9",
            opacity: 0
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                isOpen: isOpen,
                onClick: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuPanel, {
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "main",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fredcon26MobileMenu_styled_HeaderContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSubTitle, {
                                                children: t("fredcon.the-one-and-only")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogo, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: (0,paths/* getPublicPath */.A)("/images/fredcon26/fredcon-logo.png"),
                                                    alt: "Fredcon26 logo"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                                        onClick: onClose,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                            icon: pro_solid_svg_icons/* faTimes */.NBC,
                                            size: "xl"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItems, {
                                children: [
                                    [
                                        {
                                            to: "agenda",
                                            label: t("fredcon.header.nav-1")
                                        },
                                        {
                                            to: "donde",
                                            label: t("fredcon.header.nav-2")
                                        },
                                        {
                                            to: "speakers",
                                            label: t("fredcon.header.nav-3")
                                        },
                                        {
                                            to: "contacto",
                                            label: t("fredcon.header.nav-5")
                                        }
                                    ].map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                                    to: item.to,
                                                    href: "#".concat(item.to),
                                                    smooth: true,
                                                    duration: 500,
                                                    offset: -64,
                                                    onClick: onClose,
                                                    containerId: "fredcon-page-wrapper",
                                                    children: item.label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "underline",
                                                    children: Array.from({
                                                        length: 4
                                                    }).map(function() {
                                                        return pixelSequence;
                                                    }).flat().map(function(pixel, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26MobileMenu_styled_Pixel, {
                                                            color: pixel.color,
                                                            opacity: pixel.opacity
                                                        }, i);
                                                    })
                                                })
                                            ]
                                        }, item.to);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26TicketButton, {
                                        className: "menu-ticket-button"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fredcon26MobileMenu_styled_Footer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fredcon26MobileMenu_styled_FooterLinks, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26MobileMenu_styled_Copyright, {
                                        children: t("fredcon.copyright", {
                                            year: new Date().getFullYear()
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                        href: "https://www.getmanfred.com/terms-of-use",
                                        target: "_blank",
                                        children: t("fredcon.footer.nav.terms")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                        href: "https://www.getmanfred.com/privacy-policy",
                                        target: "_blank",
                                        children: t("fredcon.footer.nav.privacy")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                        href: "https://www.getmanfred.com/cookies",
                                        target: "_blank",
                                        children: t("fredcon.footer.nav.cookies")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialMedia, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialIcon, {
                                                href: "https://twitter.com/getmanfred",
                                                target: "_blank",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                                        icon: XTwitterIcon/* faXTwitter */.N,
                                                        size: "5xl"
                                                    }),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialIcon, {
                                                href: "https://t.me/getmanfred",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TelegramIcon, {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeSquare, {
                        color: "#c5fe79",
                        top: "18%",
                        right: "15%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeSquare, {
                        color: "#836FFF",
                        top: "45%",
                        right: "10%",
                        width: "100px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeSquare, {
                        color: "#ff6e23",
                        top: "calc(89% - 50px)",
                        right: "5%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DecorativeSquare, {
                        color: "#ffb6fb",
                        top: "89%",
                        right: "calc(5% + 50px)"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(97143);
;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/Fredcon26Speaker.tsx

function Fredcon26Speaker_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  overflow: clip;\n  position: relative;\n  width: 240px;\n  border: none;\n  outline: none;\n\n  @media (max-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    max-width: clamp(400px, 80vw, 540px);\n    margin: 0 auto;\n  }\n"
    ]);
    Fredcon26Speaker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Fredcon26Speaker_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 240px;\n  width: 240px;\n  background-color: ",
        ";\n  flex-shrink: 0;\n  border: none;\n  outline: none;\n\n  .scaled-photo-container {\n    position: absolute;\n    top: 45%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 90%;\n    height: 90%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    z-index: 0;\n  }\n\n  .photo-wrapper {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .speaker-photo {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  @media (max-width: ",
        ") {\n    width: clamp(127px, 35vw, 240px);\n    height: auto;\n    aspect-ratio: 1 / 1;\n  }\n"
    ]);
    Fredcon26Speaker_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Fredcon26Speaker_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n  mask: url('/images/fredcon26/pixels.svg') no-repeat center;\n  mask-size: cover;\n  z-index: 1;\n  pointer-events: none;\n"
    ]);
    Fredcon26Speaker_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Fredcon26Speaker_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 20px 14px;\n  width: 100%;\n  text-transform: uppercase;\n  z-index: 2;\n\n  @media (max-width: ",
        ") {\n    padding: clamp(16px, 2.9vw, 20px);\n    height: auto;\n    flex: 1;\n    justify-content: center;\n  }\n"
    ]);
    Fredcon26Speaker_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Fredcon26Speaker_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 4px;\n  font-family: 'Archivo Narrow', sans-serif;\n  font-weight: 600;\n  font-size: 28px;\n  white-space: nowrap;\n  align-items: center;\n\n  .name {\n    color: ",
        ";\n  }\n\n  .surname {\n    color: #3053f9;\n  }\n\n  @media (max-width: ",
        ") {\n    font-size: clamp(20px, 4.1vw, 28px);\n    line-height: 1.1;\n  }\n"
    ]);
    Fredcon26Speaker_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Fredcon26Speaker_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-weight: 400;\n  font-size: 20px;\n  color: ",
        ";\n  line-height: 1.2;\n  margin: 0;\n\n  @media (max-width: ",
        ") {\n    font-size: 19px;\n    line-height: 1.2;\n  }\n"
    ]);
    Fredcon26Speaker_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Fredcon26Speaker_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #3053f9;\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n  transition: opacity 0.2s ease;\n  width: 24px;\n  height: 24px;\n  overflow: visible;\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  svg {\n    width: 24px !important;\n    height: 24px !important;\n    pointer-events: none;\n  }\n"
    ]);
    Fredcon26Speaker_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var Fredcon26Speaker_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2cfa80a2-0"
})(Fredcon26Speaker_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("md"));
var PhotoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2cfa80a2-1"
})(Fredcon26Speaker_templateObject1(), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("md"));
var PixelsOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2cfa80a2-2"
})(Fredcon26Speaker_templateObject2(), function(param) {
    var _$color = param.color;
    return _$color;
});
var TextContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2cfa80a2-3"
})(Fredcon26Speaker_templateObject3(), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("md"));
var NameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2cfa80a2-4"
})(Fredcon26Speaker_templateObject4(), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md"));
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2cfa80a2-5"
})(Fredcon26Speaker_templateObject5(), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md"));
var LinkedinLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-2cfa80a2-6"
})(Fredcon26Speaker_templateObject6());
var Fredcon26Speaker = function(param) {
    var borderColor = param.borderColor, speakerPhoto = param.speakerPhoto, name = param.name, surname = param.surname, descriptionKey = param.descriptionKey, linkedinUrl = param.linkedinUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fredcon26Speaker_Wrapper, {
        borderColor: borderColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhotoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "scaled-photo-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "photo-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: speakerPhoto,
                                alt: "".concat(name, " ").concat(surname),
                                className: "speaker-photo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PixelsOverlay, {
                        color: borderColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NameWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "name",
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "surname",
                                children: surname
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "fredcon26",
                            i18nKey: descriptionKey
                        })
                    }),
                    linkedinUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinLink, {
                        href: linkedinUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                            icon: free_brands_svg_icons/* faLinkedin */.D9H
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/Fredcon26AgendaItem.tsx

function Fredcon26AgendaItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 16px 24px;\n  width: 100%;\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    gap: 8px;\n    padding: 16px 0;\n  }\n"
    ]);
    Fredcon26AgendaItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Fredcon26AgendaItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 12px;\n  padding-top: 4px;\n  align-items: center;\n  justify-content: flex-end;\n  width: 200px;\n  flex-shrink: 0;\n\n  @media (max-width: ",
        ") {\n    width: auto;\n    justify-content: flex-start;\n    align-items: flex-end;\n    gap: 8px;\n  }\n"
    ]);
    Fredcon26AgendaItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Fredcon26AgendaItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n\n  p {\n    font-family: 'Geist Mono', monospace;\n    font-size: 20px;\n    color: ",
        ";\n    line-height: 1;\n    margin: 0;\n    white-space: nowrap;\n\n    @media (max-width: ",
        ") {\n      font-size: 16px;\n      line-height: 16px;\n    }\n  }\n"
    ]);
    Fredcon26AgendaItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Fredcon26AgendaItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Geist Mono', monospace;\n  font-size: 24px;\n  color: ",
        ";\n  margin: 0;\n  line-height: 24px;\n"
    ]);
    Fredcon26AgendaItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Fredcon26AgendaItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n\n  @media (max-width: ",
        ") {\n    width: 100%;\n    gap: 8px;\n  }\n"
    ]);
    Fredcon26AgendaItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Fredcon26AgendaItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-family: 'Archivo Narrow', sans-serif;\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    Fredcon26AgendaItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Fredcon26AgendaItem_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  line-height: 32px;\n  margin: 0;\n\n  @media (max-width: ",
        ") {\n    font-size: 24px;\n    line-height: 30px;\n  }\n"
    ]);
    Fredcon26AgendaItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Fredcon26AgendaItem_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  line-height: 24px;\n  margin: 0;\n  opacity: 0.8;\n\n  @media (max-width: ",
        ") {\n    font-size: 19px;\n    line-height: 22px;\n  }\n"
    ]);
    Fredcon26AgendaItem_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Fredcon26AgendaItem_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Archivo Narrow', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  color: ",
        ";\n  margin: 0;\n\n  @media (max-width: ",
        ") {\n    font-size: 19px;\n    line-height: 24px;\n  }\n"
    ]);
    Fredcon26AgendaItem_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var Fredcon26AgendaItem_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4819090c-0"
})(Fredcon26AgendaItem_templateObject(), (0,theme/* screen */.sp)("md2"));
var TimeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4819090c-1"
})(Fredcon26AgendaItem_templateObject1(), (0,theme/* screen */.sp)("md2"));
var TimeBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4819090c-2"
})(Fredcon26AgendaItem_templateObject2(), function(param) {
    var isBreak = param.isBreak;
    return isBreak ? "#C5FE79" : "#3053F9";
}, function(param) {
    var isBreak = param.isBreak;
    return isBreak ? (0,theme/* color */.$_)("black") : (0,theme/* color */.$_)("white");
}, (0,theme/* screen */.sp)("md2"));
var TimeSeparator = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4819090c-3"
})(Fredcon26AgendaItem_templateObject3(), (0,theme/* color */.$_)("black"));
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4819090c-4"
})(Fredcon26AgendaItem_templateObject4(), (0,theme/* screen */.sp)("md2"));
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4819090c-5"
})(Fredcon26AgendaItem_templateObject5(), (0,theme/* color */.$_)("black"));
var Title = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4819090c-6"
})(Fredcon26AgendaItem_templateObject6(), (0,theme/* screen */.sp)("md2"));
var Subtitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4819090c-7"
})(Fredcon26AgendaItem_templateObject7(), (0,theme/* screen */.sp)("md2"));
var Speaker = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4819090c-8"
})(Fredcon26AgendaItem_templateObject8(), (0,theme/* color */.$_)("black"), (0,theme/* screen */.sp)("md2"));
var Fredcon26AgendaItem = function(param) {
    var startTime = param.startTime, endTime = param.endTime, title = param.title, subtitle = param.subtitle, speaker = param.speaker, isBreak = param.isBreak;
    var isTBD = title === "TBD" || !title;
    var finalTitle = isTBD && speaker ? speaker : title;
    // We hide subtitles and speaker labels if we are using the speaker as title,
    // or if they are explicitly requested to be hidden for now.
    var showExtraInfo = !isBreak && !isTBD && speaker !== finalTitle;
    var hasStart = !!startTime;
    var hasEnd = !!endTime;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fredcon26AgendaItem_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimeContainer, {
                children: [
                    hasStart && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeBox, {
                        isBreak: isBreak,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: startTime
                        })
                    }),
                    hasStart && hasEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeSeparator, {
                        children: "-"
                    }),
                    hasEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeBox, {
                        isBreak: isBreak,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: endTime
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                        children: [
                            finalTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: finalTitle
                            }),
                            subtitle && showExtraInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                children: subtitle
                            })
                        ]
                    }),
                    speaker && showExtraInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Speaker, {
                        children: speaker
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/Fredcon26PartnerBadge.tsx

function Fredcon26PartnerBadge_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  position: relative;\n  min-height: 40px;\n  max-width: 100vw;\n"
    ]);
    Fredcon26PartnerBadge_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Fredcon26PartnerBadge_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  background: url('/images/fredcon26/partner-badge-head.svg') no-repeat center;\n  background-size: 100% 100%;\n  transform: rotate(180deg);\n  flex-shrink: 0;\n  margin-right: -2px; /* Overlap with body to hide gaps */\n  position: relative;\n  z-index: 1;\n"
    ]);
    Fredcon26PartnerBadge_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Fredcon26PartnerBadge_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #3053f9;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 16px;\n  position: relative;\n  z-index: 0;\n  max-width: calc(100vw - 80px);\n\n  p {\n    font-family: 'Archivo Narrow', sans-serif;\n    font-weight: 600;\n    font-size: clamp(19px, 2vw, 24px);\n    color: ",
        ";\n    line-height: 1.2;\n    margin: 0;\n    text-transform: uppercase;\n    white-space: normal;\n    text-align: center;\n  }\n"
    ]);
    Fredcon26PartnerBadge_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Fredcon26PartnerBadge_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  background: url('/images/fredcon26/partner-badge-tail.svg') no-repeat center;\n  background-size: 100% 100%;\n  flex-shrink: 0;\n  margin-left: -2px;\n  position: relative;\n  z-index: 1;\n"
    ]);
    Fredcon26PartnerBadge_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Fredcon26PartnerBadge_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9df86e5-0"
})(Fredcon26PartnerBadge_templateObject());
var Head = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9df86e5-1"
})(Fredcon26PartnerBadge_templateObject1());
var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9df86e5-2"
})(Fredcon26PartnerBadge_templateObject2(), (0,theme/* color */.$_)("white"));
var Tail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d9df86e5-3"
})(Fredcon26PartnerBadge_templateObject3());
var Fredcon26PartnerBadge = function(param) {
    var text = param.text, className = param.className, style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fredcon26PartnerBadge_Wrapper, {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: text
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tail, {})
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/Fredcon26Cursor.tsx

function Fredcon26Cursor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 64px;\n  height: 64px;\n  pointer-events: none;\n  z-index: 2147483647;\n  will-change: transform;\n\n  @media (hover: none) and (pointer: coarse) {\n    display: none;\n  }\n"
    ]);
    Fredcon26Cursor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Fredcon26Cursor_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background-image: ",
        ";\n  background-size: contain;\n  background-repeat: no-repeat;\n"
    ]);
    Fredcon26Cursor_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var CursorContainer = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(param) {
    var $x = param.$x, $y = param.$y;
    return {
        style: {
            transform: "translate3d(".concat($x - 22, "px, ").concat($y, "px, 0)")
        }
    };
}).withConfig({
    componentId: "sc-a022c133-0"
})(Fredcon26Cursor_templateObject());
var CursorImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a022c133-1"
})(Fredcon26Cursor_templateObject1(), function(props) {
    return "url(".concat((0,paths/* getPublicPath */.A)(props.$isPointer ? "/images/fredcon26/fredcon-cursor-pointer.png" : "/images/fredcon26/fredcon-cursor.png"), ")");
});
var Fredcon26Cursor = function() {
    var ref = (0,react.useState)({
        x: -100,
        y: -100
    }), position = ref[0], setPosition = ref[1];
    var ref1 = (0,react.useState)(false), isPointer = ref1[0], setIsPointer = ref1[1];
    var ref2 = (0,react.useState)(false), isVisible = ref2[0], setIsVisible = ref2[1];
    (0,react.useEffect)(function() {
        var updateCursor = function(e) {
            var target = e.target;
            // If we are over an iframe or Cookiebot dialog, hide the custom cursor and let the default cursor take over
            if (target && (target.tagName === "IFRAME" || target.closest("#CybotCookiebotDialog, #CookiebotSessionDialog"))) {
                setIsVisible(false);
                return;
            }
            setPosition({
                x: e.clientX,
                y: e.clientY
            });
            if (!isVisible) setIsVisible(true);
            var isClickable = target && target.closest('a, button, [role="button"], .cursor-pointer, select, label') !== null;
            setIsPointer(isClickable);
        };
        var onMouseLeave = function() {
            return setIsVisible(false);
        };
        var onMouseEnter = function() {
            return setIsVisible(true);
        };
        window.addEventListener("mousemove", updateCursor, {
            passive: true
        });
        window.addEventListener("mouseover", updateCursor, {
            passive: true
        });
        document.body.addEventListener("mouseleave", onMouseLeave);
        document.body.addEventListener("mouseenter", onMouseEnter);
        return function() {
            window.removeEventListener("mousemove", updateCursor);
            window.removeEventListener("mouseover", updateCursor);
            document.body.removeEventListener("mouseleave", onMouseLeave);
            document.body.removeEventListener("mouseenter", onMouseEnter);
        };
    }, [
        isVisible
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CursorContainer, {
        $x: position.x,
        $y: position.y,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CursorImage, {
            $isPointer: isPointer
        })
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/Fredcon26.tsx




















var BASE_URL = "https://www.getmanfred.com";
var Fredcon26 = function() {
    var t = (0,useI18n/* useI18n */.Q)("fredcon26").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(false), isMenuOpen = ref[0], setIsMenuOpen = ref[1];
    var WRAPPER_ID = "fredcon-page-wrapper";
    var Header = /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26_styled_Header, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderGroup, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuButton, {
                            type: "button",
                            onClick: function() {
                                return setIsMenuOpen(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                icon: pro_solid_svg_icons/* faBars */.xiG,
                                size: "xl"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: BASE_URL,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavLogo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,paths/* getPublicPath */.A)("/images/fredcon26/manfred-logo.png"),
                                    alt: "Manfred logo"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderActions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNav, {
                            children: [
                                {
                                    to: "agenda",
                                    label: t("fredcon.header.nav-1")
                                },
                                {
                                    to: "donde",
                                    label: t("fredcon.header.nav-2")
                                },
                                {
                                    to: "speakers",
                                    label: t("fredcon.header.nav-3")
                                },
                                {
                                    to: "contacto",
                                    label: t("fredcon.header.nav-5")
                                }
                            ].map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                            to: item.to,
                                            href: "#".concat(item.to),
                                            duration: 500,
                                            spy: true,
                                            offset: -64,
                                            containerId: WRAPPER_ID,
                                            children: item.label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "underline",
                                            children: Array.from({
                                                length: 4
                                            }).map(function() {
                                                return [
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#c5fe79"
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#ffb6fb"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#ffb6fb"
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#c5fe79"
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#ff6e23"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#836fff"
                                                    },
                                                    {
                                                        color: "#c5fe79",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#ff6e23"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#c5fe79",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#ffb6fb"
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#836fff"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9"
                                                    },
                                                    {
                                                        color: "#836fff"
                                                    },
                                                    {
                                                        color: "#c5fe79",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    },
                                                    {
                                                        color: "#3053f9",
                                                        opacity: 0
                                                    }
                                                ];
                                            }).flat().map(function(pixel, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pixel, {
                                                    color: pixel.color,
                                                    opacity: pixel.opacity
                                                }, i);
                                            })
                                        })
                                    ]
                                }, item.to);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26TicketButton, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26MobileMenu, {
                    isOpen: isMenuOpen,
                    onClose: function() {
                        return setIsMenuOpen(false);
                    }
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageWrapper, {
        id: WRAPPER_ID,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26Cursor, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26GlobalStyles, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
                children: [
                    Header,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroInner, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSubTitle, {
                                    children: t("fredcon.hero.title-pre")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroTitle, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,paths/* getPublicPath */.A)("/images/fredcon26/fredcon-logo-white.png"),
                                        alt: t("fredcon.hero.logo"),
                                        className: "logo-img"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoweredBy, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: t("fredcon.powered-by")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/google-cloud-hero.svg"),
                                            alt: "Powered by Google Cloud"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroTagline, {
                                    children: t("fredcon.hero.desc")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroDate, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("fredcon.hero.date")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26TicketButton, {
                                    text: t("fredcon.hero.view-program"),
                                    href: "#agenda"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Speakers, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "speakers",
                                id: "speakers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("fredcon.speakers.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakersContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Stack */.Kq, {
                                    wrap: true,
                                    gap: "3xl",
                                    contentAlign: "center",
                                    style: {
                                        width: "100%"
                                    },
                                    children: Array.from({
                                        length: 9
                                    }).map(function(_, index) {
                                        var pixelColors = [
                                            "#3053f9",
                                            "#ff6e23",
                                            "#836fff",
                                            "#FFB6FB",
                                            "#c5fe79",
                                            "#c5fe79",
                                            "#ff6e23",
                                            "#836fff",
                                            "#FFB6FB"
                                        ];
                                        var borderColor = pixelColors[index % pixelColors.length];
                                        var speakerName = t("fredcon.speakers.speaker-".concat(index + 1, ".name"));
                                        var speakerSurname = t("fredcon.speakers.speaker-".concat(index + 1, ".surname"));
                                        var speakerDescKey = "fredcon.speakers.speaker-".concat(index + 1, ".desc");
                                        var linkedinUrl = t("fredcon.speakers.speaker-".concat(index + 1, ".linkedin"));
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26Speaker, {
                                            borderColor: borderColor,
                                            name: speakerName,
                                            surname: speakerSurname,
                                            descriptionKey: speakerDescKey,
                                            linkedinUrl: linkedinUrl,
                                            speakerPhoto: (0,paths/* getPublicPath */.A)("/images/fredcon26/speaker-".concat(index + 1, ".png"))
                                        }, index);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoInner, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(What, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: t("fredcon.what.title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatDesc, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                ns: "fredcon26",
                                                i18nKey: "fredcon.what.desc"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Where, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "donde",
                                                    id: "donde"
                                                }),
                                                t("fredcon.where.title")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "where-content",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WhereDesc, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                        ns: "fredcon26",
                                                        i18nKey: "fredcon.where.desc"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.9897840543754!2d-3.7068436000000005!3d40.4090771!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4227fc14e5d533%3A0xd840f5b434384bc7!2sEspacio%20Rastro%20Madrid!5e0!3m2!1sen!2ses!4v1747216832762!5m2!1sen!2ses",
                                                    style: {
                                                        border: 0
                                                    },
                                                    allowFullScreen: false,
                                                    loading: "lazy",
                                                    referrerPolicy: "no-referrer-when-downgrade"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Agenda, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "agenda",
                                id: "agenda"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("fredcon.agenda.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AgendaList, {
                                children: Array.from({
                                    length: 15
                                }).map(function(_, index) {
                                    var itemKey = "fredcon.agenda.item-".concat(index + 1);
                                    var getTranslation = function(key) {
                                        var value = t(key);
                                        return value === key ? "" : value;
                                    };
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26AgendaItem, {
                                        startTime: getTranslation("".concat(itemKey, ".startTime")),
                                        endTime: getTranslation("".concat(itemKey, ".endTime")),
                                        title: getTranslation("".concat(itemKey, ".title")),
                                        subtitle: getTranslation("".concat(itemKey, ".subtitle")),
                                        speaker: getTranslation("".concat(itemKey, ".speaker")),
                                        isBreak: getTranslation("".concat(itemKey, ".isBreak")) === "true"
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tickets, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "entradas",
                                id: "entradas"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TicketsInner, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketsSubTitle, {
                                        children: t("fredcon.tickets.subtitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketsTitle, {
                                        children: t("fredcon.tickets.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketsDesc, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                            ns: "fredcon26",
                                            i18nKey: "fredcon.tickets.desc"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26TicketButton, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Partners, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "partners",
                                id: "partners"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("fredcon.partners.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tiers, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tier, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26PartnerBadge, {
                                                text: "King"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                href: t("fredcon.partners.partner-google.url"),
                                                target: "_blank",
                                                tier: "king",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-google.png"),
                                                    alt: t("fredcon.partners.partner-google.name")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tier, {
                                        style: {
                                            marginTop: "12px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26PartnerBadge, {
                                                text: "Manfredo Partners"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PartnerList, {
                                                className: "partner-list-3-max",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                        href: t("fredcon.partners.partner-540.url"),
                                                        target: "_blank",
                                                        tier: "partner",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-540.png"),
                                                            alt: t("fredcon.partners.partner-540.name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                        href: t("fredcon.partners.partner-orbitant.url"),
                                                        target: "_blank",
                                                        tier: "partner",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-orbitant.png"),
                                                            alt: t("fredcon.partners.partner-orbitant.name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                        href: t("fredcon.partners.partner-sngular.url"),
                                                        target: "_blank",
                                                        tier: "partner",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-sngular.png"),
                                                            alt: t("fredcon.partners.partner-sngular.name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                        href: t("fredcon.partners.partner-next-digital.url"),
                                                        target: "_blank",
                                                        tier: "collaborator",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-next-digital.png"),
                                                            alt: t("fredcon.partners.partner-next-digital.name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                        href: t("fredcon.partners.partner-helmcode.url"),
                                                        target: "_blank",
                                                        tier: "partner",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-helmcode.png"),
                                                            alt: t("fredcon.partners.partner-helmcode.name")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tier, {
                                        style: {
                                            marginTop: "12px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26PartnerBadge, {
                                                text: "Manfredo Collaborators"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PartnerList, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                        href: t("fredcon.partners.partner-osohub.url"),
                                                        target: "_blank",
                                                        tier: "collaborator",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-osohub.png"),
                                                            alt: t("fredcon.partners.partner-osohub.name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                        href: t("fredcon.partners.partner-raiola.url"),
                                                        target: "_blank",
                                                        tier: "collaborator",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-raiola.png"),
                                                            alt: t("fredcon.partners.partner-raiola.name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                        href: t("fredcon.partners.partner-panel.url"),
                                                        target: "_blank",
                                                        tier: "partner",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-panel.jpg"),
                                                            alt: t("fredcon.partners.partner-panel.name")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Partner, {
                                                        href: t("fredcon.partners.partner-iceye.url"),
                                                        target: "_blank",
                                                        tier: "partner",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,paths/* getPublicPath */.A)("/images/fredcon26/partner-iceye.jpg"),
                                                            alt: t("fredcon.partners.partner-iceye.name")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersDivider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersFooterText, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "fredcon26",
                                    i18nKey: "fredcon.partners.footer-text"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "contacto",
                                id: "contacto"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterContent, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterRow1, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FredConLogoBlack, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("fredcon.the-one-and-only")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (0,paths/* getPublicPath */.A)("/images/fredcon26/fredcon-logo-black.png"),
                                                        alt: "FredCon 26"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoweredByGoogleBlack, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("fredcon.powered-by")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: (0,paths/* getPublicPath */.A)("/images/fredcon26/powered-google-black.png"),
                                                        alt: "Powered by Google"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ManfredLogoMonocolor, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: (0,paths/* getPublicPath */.A)("/images/fredcon26/manfred-logo-monocolor.png"),
                                                    alt: "Manfred"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterRow2, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Copyright, {
                                                children: [
                                                    "\xa9 ",
                                                    new Date().getFullYear(),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "Manfred Tech"
                                                    }),
                                                    " S.L."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterLinks, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "".concat(BASE_URL).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.termsOfUse */.uu.termsOfUse, locale)),
                                                        target: "_blank",
                                                        children: t("fredcon.footer.nav.terms")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "".concat(BASE_URL).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.privacyPolicy */.uu.privacyPolicy, locale)),
                                                        target: "_blank",
                                                        children: t("fredcon.footer.nav.privacy")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "".concat(BASE_URL).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.cookies */.uu.cookies, locale)),
                                                        target: "_blank",
                                                        children: t("fredcon.footer.nav.cookies")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialLinks, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://twitter.com/getmanfred",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                                            icon: XTwitterIcon/* faXTwitter */.N
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://t.me/getmanfred",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TelegramIcon, {})
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/fredcon26/index.ts


// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/fredcon26.tsx







var ManTechCar26Page = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("fredcon26").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.googleapis.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.gstatic.com",
                crossOrigin: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "https://fonts.googleapis.com/css2?family=Archivo+Narrow:ital,wght@0,400..700;1,400..700&family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&family=Geist+Mono:wght@100..900&display=swap",
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("fredcon.page_title"),
                url: app_urls/* APP_URLS.fredcon26 */.uu.fredcon26,
                desc: t("fredcon.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_fredcon26.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: "https://fredcon.io/fredcon26"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fredcon26, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var fredcon26 = (ManTechCar26Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(34900); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);